import { createReducer, on } from '@ngrx/store';
import { initialDeviceState } from './device.state';
import { setIsMobile } from './device.actions';

export const deviceReducer = createReducer(
  initialDeviceState,
  on(setIsMobile, (state, { isMobile }) => ({ ...state, isMobile })),
);
